import { IconProps } from './IconProps';

export const LightingMediumIcon = ({ className, width = 31, height = 32 }: IconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 31 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#2396FD" fillRule="nonzero">
      <path d="M14.151.5h2.461v6.153h-2.461zM14.151 25.111h2.461v6.152h-2.461zM0 14.652h6.152v2.462H0zM24.611 14.652h6.152v2.462h-6.152zM3.635 5.873l1.74-1.74 4.351 4.352-1.74 1.74zM21.036 23.277l1.74-1.74 4.35 4.35-1.74 1.74zM5.375 27.628l-1.74-1.74 4.351-4.35 1.74 1.74zM21.037 8.487l1.742 1.74 4.35-4.35-1.739-1.742z" />
    </g>
  </svg>
);
